<!-- #region HTML -->

<template>
  <div class="app">
    <alert ref="alertComponent" :SystemErrorAlert="isSystemError" :logoutSuccess="showAlert"
      @update:SystemErrorAlert="isSystemError = $event" @update:logoutSuccess="showAlert = $event"></alert>

    <div class="main-container">
      <div class="title">
        <label>登録センター</label>
      </div>
      <div class="page-container">

        <!-- #region Buttons Section -->

        <div class="buttons-div">

          <!-- #region Button for Signup / Change Email -->

          <md-button v-if="signedIn === false" class="link-button" @click="openLink('/signup')">
            <div class="sub-container">
              アカウントの新規登録
              <img src="@/assets/img/enter.svg" class="icon-image" />
            </div>
          </md-button>

          <md-button v-if="signedIn === true" class="link-button" @click="openLink('/change-email')">
            <div class="sub-container">
              メールアドレス変更
              <img src="@/assets/img/enter.svg" class="icon-image" />
            </div>
          </md-button>

          <!-- #endregion -->

          <!-- #region Button for Forgot Password / Change Password -->

          <md-button v-if="signedIn === false" class="link-button" @click="openLink('/forgot-password')">
            <div class="sub-container">
              パスワード再設定
              <img src="@/assets/img/enter.svg" class="icon-image" />
            </div>
          </md-button>

          <md-button v-if="signedIn === true" class="link-button" @click="openLink('/change-password')">
            <div class="sub-container">
              パスワード変更
              <img src="@/assets/img/enter.svg" class="icon-image" />
            </div>
          </md-button>

          <!-- #endregion -->

          <!-- #region Button for Sign In / Change Opt-In -->

          <md-button v-if="signedIn === false" class="link-button" @click="openLink('/signin')">
            <div class="sub-container">
              <label class="tablet-hide">「登録センター」 ログイン</label>
              <label class="tablet-show">「登録センター」<br>ログイン</label>
              <img src="@/assets/img/enter.svg" class="icon-image" />
            </div>
          </md-button>

          <md-button v-if="signedIn === true" class="link-button" @click="openLink('/change-opt-in')">
            <div class="sub-container">
              <label class="tablet-hide">メールマガジン等の配信設定</label>
              <label class="tablet-show">メールマガジン<br>等の配信設定</label>
              <img src="@/assets/img/enter.svg" class="icon-image" />
            </div>
          </md-button>

          <!-- #endregion -->

        </div>

        <!-- ＃endregion -->

        <!-- #region Separator -->
        <div class="separator-container">
          <div class="separator">
            <div class="line"></div>
            <img src="@/assets/img/link.svg" class="symbol" />
            <div class="line"></div>
          </div>
        </div>
        <!-- ＃endregion -->

        <!-- #region Card Section -->
        <div class="card-section">
          <div class="card">
            <img src="@/assets/img/logo-eowp.svg" alt="英辞郎 on the WEB Pro" class="card-logo-eowp" />
            <div class="description">広告無し、豊富な例文・用例で<br>学びと仕事をサポートできます。<br>
              初めてのお申し込みは2週間無料!</div>
            <button class="primary-button" @click="openLink('https://eowp-shop.alc.co.jp/products?utm_source=eowp-user&utm_medium=banner&utm_campaign=eowf_serp_product')">お申し込み</button>
          </div>
          <div class="card height-auto">
            <img src="@/assets/img/logo.svg" alt="英辞郎 on the WEB" class="card-logo" />
            <img src="@/assets/img/logo-eowpf.svg" alt="英辞郎 on the WEB Pro Lite" class="card-logo-eowpf" />
            <button class="primary-button" @click="openLink('https://eowpf.alc.co.jp/login')">ログイン</button>
          </div>
          <div class="card">
            <img src="@/assets/img/logo.svg" alt="英辞郎 on the WEB Pro" class="card-logo" />
            <div class="description">アプリのダウンロード</div>
            <div class="store-section">
              <img src="@/assets/img/logo-app-store.svg" alt="App Store" class="card-logo-store"
                @click="openLink('https://apps.apple.com/app/apple-store/id365874160?pt=210463&ct=eow_top_app_store_link_2021_02&mt=8')" />
              <br>
              <img src="@/assets/img/logo-google.svg" alt="Google Play" class="card-logo-store"
                @click="openLink('https://play.google.com/store/apps/details?id=jp.co.alc.eow&referrer=utm_source%3Deow_top%26utm_medium%3Dbanner%26utm_campaign%3Dandroid_app')" />
            </div>
          </div>
        </div>
        <!-- ＃endregion -->

      </div>
    </div>
  </div>
</template>

<!-- ＃endregion -->

<!-- #region JavaScript -->

<script>
import Alert from '@/layout/Alerts.vue';

export default {
  name: "Home",
  components: {
    Alert
  },
  data: () => ({
    showAlert: false,
    isSystemError: false,
  }),
  created() {
    this.showLogoutAlert();
  },
  watch: {
    '$route'(to) {
      if (to.query.loggedOut) {
        this.showLogoutAlert();
      }
    }
  },
  methods: {
    showLogoutAlert() {
      if (this.$route.query.loggedOut === "true") {
        this.showAlert = true;
        setTimeout(() => {
          if (this.$refs.alertComponent) {
            this.$refs.alertComponent.closeAlert('logoutSuccess');
          }
          if (this.$route.query.loggedOut) {
            this.$router.push({ query: {} });
          }
        }, 5000);
      }
    },
    openLink(url) {
      window.location.href = url;
    }
  },
  props: {
    signedIn: {
      type: Boolean,
      required: true
    }
  }
};
</script>


<!-- ＃endregion -->

<!-- #region CSS -->

<style lang="scss" scoped>
/* #region SP 768~925px (Tablet) */

@media (min-width: 769px) and (max-width: 925px) {

  /* #region Dynamic Button  */

  .link-button {
    width: 240px !important;
    height: var(--btn-lr-margin) !important;
    flex-shrink: 0;
  }

  .link-button:not(:last-child) {
    margin-right: 10px !important;
  }

  .tablet-show {
    display: block !important;
  }

  .tablet-hide {
    display: none !important;
  }

  /* #endregion */

  /* #region Dynamic Card */

  .card:not(:last-child) {
    margin-right: 10px !important;
  }

  .card {
    width: 240px !important;
    height: 280px !important;
  }

  .card-logo {
    width: 155px !important;
    height: 33px !important;
  }

  .card-logo-eowp {
    width: 220px !important;
    height: 33px !important;
  }

  /* #endregion */

}

/* #endregion */

/* #region SP ~768px */

@media (max-width: 768px) {

  /* #region Page */
  .height-auto {
    height: 224px !important;
  }

  .page-container {
    width: 100% !important;
  }

  /* #endregion */

  /* #region Dynamic Button */

  .buttons-div {
    gap: 10px !important;
  }

  .link-button {
    width: 100% !important;
    height: fit-content !important;
    margin-right: 0px !important;
  }

  /* #endregion */

  /* #region Dynamic Separator */

  .separator-container {
    padding: 0 !important;
  }

  .separator {
    width: 100% !important;
    display: block;
    box-sizing: border-box;
  }

  /* #endregion */

  /* #region Dynamic Card */

  .card-section {
    //gap: 0 !important;
    margin-bottom: 40px !important;
    display: block !important;
  }

  .card {
    width: 100% !important;
    margin-bottom: 10px !important;

  }

  .card-logo {
    width: 155px !important;
    height: 33px !important;
  }

  .card-logo-eowp {
    width: 220px !important;
    height: 33px !important;
  }


  /* #endregion */

}

/* #endregion */

/* #region Page */

.page-container {
  display: inline-block;
}

/* #endregion */

/* #region Buttons Style */

.buttons-div {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 20px;
}

.link-button {
  width: 280px;
  height: 80px;
  border: 1.5px solid transparent;
  border-radius: 60px;
  background-image: linear-gradient(var(--background-primary), var(--background-primary)), var(--gradient-color);
  background-clip: content-box, border-box;
  color: var(--theme-primary-color) !important;
  font-size: 18px;
  font-weight: var(--weight-strong);
}

.link-button:not(:last-child) {
  margin-right: 20px;
}

.link-button:hover {
  background-image: linear-gradient(#f3e8e9, #f3e8e9), var(--gradient-color);
  color: var(--theme-primary-color) !important;
}

.link-button:hover label{
  cursor: pointer;
}

.tablet-hide {
  display: block;
}

.tablet-show {
  display: none;
}

.sub-container {
  gap: 0px !important;
}

/* #endregion */

/* #region Separator Styles */

.separator-container {
  display: flex;
  width: 100%;
}

.separator {
  display: flex;
  align-items: center;
  flex: 1;
  margin: 40px 0 45px 0;
}

.line {
  flex: 1;
  border-top: 1px solid #ccc;
}

.symbol {
  margin: 0 28px;
}

/* #endregion */

/* #region Card Section Styles */

.card-section {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 280px;
  height: 280px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid var(--separator-primary);
  position: relative;
  flex: 1;
}

.card:not(:last-child) {
  margin-right: 20px;
}

.card-logo {
  display: flex;
  width: 170px;
  height: 36px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-bottom: 20px;
  margin-top: 30px;
}

.card-logo-eowp {
  display: flex;
  width: 240px;
  height: 36px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-bottom: 20px;
  margin-top: 30px;
}

.card-logo-eowpf {
  width: 210px;
  height: 32px;
  flex-shrink: 0;
  margin-bottom: 72px;
}

.description {
  font-weight: var(--weight-strong);
  line-height: 28px;
}

.store-section {
  position: absolute;
  bottom: 30px;
}

.card-logo-store {
  width: 175px;
  height: 50px;
  flex-shrink: 0;
  margin-top: 12px;
}

.card-logo-store:hover {
  cursor: pointer;
  opacity: 0.8;
}

.primary-button {
  width: 200px;
  height: 50px;
  flex-shrink: 0;
  position: absolute;
  bottom: 30px;
  font-size: 15px !important;
  line-height: 28px !important;
}

.primary-button:hover {
  cursor: pointer;
}

/* #endregion */
</style>

<!-- ＃endregion -->